import View from "../../../../View";
import Generator from "./Generator";
import {defer} from "../../../../atUtils";

const CHART_SIZE = {
    "height": 250,
    "width": 596
}

export default class Chart extends View {
    constructor($container, {
        onRendered = () => {}
    }) {
        super($container);

        this.params = {
            onRendered
        }

        this.state = {
            summaryRecords: [],
        }

        this.onStatePropertyChanged('summaryRecords', (summaryRecords) => {
            const $container = this.$containerEl;
            if (summaryRecords.length === 0) {
                $container.empty();
            }
            defer(() => {
                this.chartGenerator.renderChart($container[0].id, summaryRecords, {
                    "onRendered": () => this.params.onRendered()
                });
            });
        })
    }

    afterRender() {
        this.chartGenerator = new Generator().init(CHART_SIZE);
        this.$containerEl.css("height", CHART_SIZE.height);
        this.$containerEl.css("width", CHART_SIZE.width);
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/chart/Chart.js